<template>
    <div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <template v-else>
            <div class="com-btn-area">
                <div class="right-box">
                    <a class="com-btn blue" href="#" @click="openHistoryPop">급여변동내역보기</a>
                </div>
            </div>

            <p class="com-sub-title">
                기본설정
                <small>기본급과 인센티브를 설정하며 '월' 단위로 급여변경이 가능합니다.</small>
            </p>

            <div class="com-card-input half-type">
                <div class="left-box">
                    <div class="line">
                        <span class="tit">
                            기본급
                            <small>(지급하지 않는 경우 미입력)</small>
                        </span>
                        <div class="input-cnt">
                            <input v-model="data.basePay" class="w220" type="text" />
                            <span class="txt">원</span>
                        </div>
                    </div>

                    <div class="line">
                        <span class="tit">
                            종합소득세
                            <!--
                            제플린에 해당 디자인이 없기 때문에 주석 처리함.
                            <div class="com-tooltip">
                                <button class="icon"></button>
                            </div>
                            -->
                        </span>
                        <salary-tax
                            id="salary-tax"
                            :value="data.taxWithholdingAppliedYn"
                            @input="(v) => (data.taxWithholdingAppliedYn = v)"
                        />
                    </div>
                </div>
                <div class="right-box">
                    <div class="line">
                        <span class="tit">
                            인센티브
                            <small>(지급하지 않는 경우 미입력)</small>
                        </span>
                        <div class="input-cnt flex-col">
                            <div class="sub-line">
                                <div class="com-check">
                                    <input
                                        id="radio-1-1"
                                        v-model="incentiveKind"
                                        name="radio-1"
                                        type="radio"
                                        value="no"
                                    />
                                    <label for="radio-1-1">없음</label>
                                </div>
                            </div>
                            <div class="sub-line">
                                <div class="com-check w100">
                                    <input
                                        id="radio-1-2"
                                        ref="checkIncentiveNewSale"
                                        v-model="incentiveKind"
                                        name="radio-1"
                                        type="radio"
                                        value="new"
                                    />
                                    <label for="radio-1-2">신규 매출</label>
                                </div>
                                <input
                                    v-model="data.incentiveNewSale"
                                    :disabled="incentiveKind !== 'new'"
                                    class="w60 center"
                                    type="number"
                                />
                                <span class="txt">%</span>
                            </div>
                            <div class="sub-line">
                                <div class="com-check w100">
                                    <input
                                        id="radio-1-3"
                                        ref="checkIncentiveRenewSale"
                                        v-model="incentiveKind"
                                        name="radio-1"
                                        type="radio"
                                        value="renew"
                                    />
                                    <label for="radio-1-3">재등록 매출</label>
                                </div>
                                <input
                                    v-model="data.incentiveRenewSale"
                                    :disabled="incentiveKind !== 'renew'"
                                    class="w60 center"
                                    type="number"
                                />
                                <span class="txt">%</span>
                            </div>
                            <div class="sub-line">
                                <div class="com-check w100">
                                    <input
                                        id="radio-1-4"
                                        ref="checkIncentiveTotalSale"
                                        v-model="incentiveKind"
                                        name="radio-1"
                                        type="radio"
                                        value="total"
                                    />
                                    <label for="radio-1-4">총 매출</label>
                                </div>
                                <input
                                    v-model="data.incentiveTotalSale"
                                    :disabled="incentiveKind !== 'total'"
                                    class="w60 center"
                                    type="number"
                                />
                                <span class="txt">%</span>
                            </div>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">
                            인센티브 부가세 정책
                            <!--
                            제플린에 해당 디자인이 없기 때문에 주석 처리함.
                            <div class="com-tooltip">
                                <button class="icon"></button>
                            </div>
                            -->
                        </span>
                        <salary-vat
                            id="incentive-vat"
                            :value="data.incentiveVatYn"
                            @input="(v) => (data.incentiveVatYn = v)"
                        />
                    </div>
                </div>
            </div>

            <p class="com-sub-title">
                이용권 별 설정
                <small>이용권 종류별로 급여를 설정하며 '일' 단위로 급여변경이 가능합니다.</small>
            </p>

            <div class="com-card-input half-type full">
                <span class="top-title">
                    이용권 별 급여 설정
                    <small>(지급하지 않는 경우 미입력)</small>
                </span>
                <div class="left-box full">
                    <!-- 개인 급여 설정 -->
                    <salary-type
                        :codes="codes"
                        :data="data"
                        keyword="Person"
                        title="개인 급여 설정"
                        type="p"
                        @is-show="(val) => (selectedLessonTypes[0] = val)"
                        @change-data="changeData"
                    />
                    <!-- //개인 급여 설정 -->

                    <!-- 듀엣 급여 설정 -->
                    <salary-type
                        :codes="codes"
                        :data="data"
                        keyword="Duet"
                        title="듀엣 급여 설정"
                        type="d"
                        @is-show="(val) => (selectedLessonTypes[1] = val)"
                        @change-data="changeData"
                    />
                    <!-- //듀엣 급여 설정 -->

                    <!-- 오티 급여 설정 -->
                    <salary-type
                        :codes="codes"
                        :data="data"
                        keyword="Ot"
                        title="OT 급여 설정"
                        type="o"
                        @is-show="(val) => (selectedLessonTypes[2] = val)"
                        @change-data="changeData"
                    />
                    <!-- //오티 급여 설정 -->

                    <!-- 그룹/쿠폰 급여 설정 -->
                    <salary-type
                        :codes="codes"
                        :data="data"
                        keyword="Group"
                        title="그룹/쿠폰 급여 설정"
                        type="g"
                        @is-show="(val) => (selectedLessonTypes[3] = val)"
                        @change-data="changeData"
                    />
                    <!-- //그룹/쿠폰 급여 설정 -->

                    <!-- 횟수 별 급여 포함 설정 -->
                    <div
                        v-if="
                            selectedLessonTypes.find((lessonType) => lessonType === 'CA' || lessonType === 'CP') !==
                            undefined
                        "
                        class="gray-info-box"
                    >
                        <span class="title">
                            횟수 별 급여 포함 설정
                            <!--
                            제플린에 해당 디자인이 없기 때문에 주석 처리함.
                            <div class="com-tooltip">
                                <button class="icon"></button>
                            </div>
                            -->
                        </span>
                        <p class="txt">
                            위에서 설정한 횟수 별 금액 or 퍼센트에 어떤 이용권의 횟수를 포함시키겠습니까?
                            <br />
                            횟수에 포함할 모든 이용권 종류를 선택 해 주세요. (중복 선택 가능)
                        </p>
                        <div class="line">
                            <div v-for="(item, index) in codes.less_type_cd" :key="index" class="com-check">
                                <input
                                    :id="`check-less-type-${item.value}`"
                                    :checked="data.countSetting[index] == 'Y'"
                                    :disabled="isDisabled(index)"
                                    :value="item.value"
                                    name="check-less-type"
                                    type="checkbox"
                                    @input="changeValue(index)"
                                />
                                <label :for="`check-less-type-${item.value}`">{{ item.text }}</label>
                            </div>
                        </div>
                        <p class="txt">
                            ※ 위에서 선택한 이용권은 횟수만 합산될 뿐 설정한 이용권 개별 급여설정으로 적용됩니다.
                            <br />
                            ※ 1일 ~ 31일 동안 선택한 이용권 횟수의 총 합계로 횟수 별 급여 구간이 정해집니다.
                        </p>
                    </div>
                    <!-- //횟수 별 급여 포함 설정 -->
                </div>
            </div>

            <div class="bottom-btn">
                <button class="com-btn blue" @click="paySettingModify">수정</button>
            </div>

            <!-- 이용권별 수정 팝업 -->
            <div v-if="ticketSettingPop" class="layer-pop square-type">
                <div class="view-content">
                    <button class="close" @click="ticketSettingPop = false">
                        <span class="blind">팝업 닫기</span>
                    </button>
                    <div class="scroll-area" style="overflow: unset">
                        <span class="sub-title">변경 전 급여를 몇일까지 적용하시겠습니까?</span>
                        <div class="info-input-line">
                            <div class="info">
                                <span class="red">변경 전</span>
                                급여를
                                <div class="ui-month-calendar">
                                    <vue-monthly-picker
                                        v-model="data.applyEndDate"
                                        dateFormat="YYYY-MM"
                                    ></vue-monthly-picker>
                                </div>
                                까지 저장합니다.
                            </div>
                            <div class="info">
                                <span class="blue">변경 후</span>
                                급여는
                                <span class="day">{{ data.applyStartDate }}</span>
                                부터 적용됩니다.
                            </div>
                        </div>

                        <div class="bottom-btn">
                            <btn-loading-spinner v-if="isSaving"></btn-loading-spinner>
                            <template v-else>
                                <button class="com-btn" @click="ticketSettingPop = false">취소</button>
                                <button class="com-btn blue" @click="save">적용</button>
                            </template>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 듀엣 및 그룹의 급여 설정 유형 변경 시 팝업창 -->
            <div v-if="defaultSettingPop" class="layer-pop square-type">
                <div class="view-content">
                    <button class="close" @click="defaultSettingPop = false">
                        <span class="blind">팝업 닫기</span>
                    </button>
                    <div class="scroll-area" style="overflow: unset">
                        <span class="sub-title">
                            듀엣, 그룹 급여 유형이 변경된 경우에는 이용권 정산내역에서 수기로 수정한 정산금액도 변경된
                            급여유형으로 재정산 됩니다. 급여 설정 내용을 수정하시겠습니까?
                        </span>

                        <div class="bottom-btn">
                            <btn-loading-spinner v-if="isSaving"></btn-loading-spinner>
                            <template v-else>
                                <button class="com-btn" @click="defaultSettingPop = false">취소</button>
                                <button class="com-btn blue" @click="next">다음</button>
                            </template>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 급여변동 내역 팝업 -->
            <div v-if="historyPop" class="layer-pop square">
                <div class="view-content w1100">
                    <button class="close" @click="historyPop = false"><span class="blind">팝업 닫기</span></button>
                    <div class="scroll-area com-scroll-y">
                        <span class="title">급여변동내역</span>
                        <loading-spinner v-if="isHistoryLoading"></loading-spinner>
                        <ul class="history-list">
                            <li v-for="(item, index) in history" :key="index">
                                <span class="day">
                                    {{ $moment(item.applyStartDate).format('YYYY년 M월') }} ~
                                    {{
                                        item.applyEndDate
                                            ? $moment(item.applyEndDate).format('YYYY년 M월 DD일')
                                            : '현재'
                                    }}
                                </span>
                                <div class="line">
                                    <span class="txt">기본급</span>
                                    <span class="detail">{{ item.basePay | numberFormatFilter }} 원</span>
                                </div>
                                <div v-if="true === item.taxWithholdingAppliedYn" class="line">
                                    <span class="txt">종합소득세</span>
                                    <span class="detail">3.3%</span>
                                </div>
                                <div class="line">
                                    <span class="txt">인센티브</span>
                                    <span v-if="!item.incentiveYn" class="detail">없음</span>
                                    <span v-else-if="item.incentiveNewSale > 0" class="detail">
                                        신규 매출의 {{ item.incentiveNewSale }}%
                                    </span>
                                    <span v-else-if="item.incentiveRenewSale > 0" class="detail">
                                        재등록 매출의 {{ item.incentiveRenewSale }}%
                                    </span>
                                    <span v-else-if="item.incentiveTotalSale > 0" class="detail">
                                        총 매출의 {{ item.incentiveTotalSale }}%
                                    </span>
                                </div>
                                <div
                                    v-for="(keyword, i) in ['Person', 'Duet', 'Ot', 'Group']"
                                    :key="i"
                                    class="line w1000"
                                >
                                    <span class="txt">{{ getTicketTitle(keyword) }}</span>
                                    <span
                                        v-if="['FP', 'FA', 'MO', 'TM'].includes(item[`lesson${keyword}Type`])"
                                        class="detail"
                                    >
                                        {{ getLessonTypeString(item[`lesson${keyword}Type`]) }} -
                                        {{ item[`lesson${keyword}Price`] | numberFormatFilter }}
                                        {{ getDimension(item[`lesson${keyword}Type`]) }}
                                    </span>
                                    <span v-else-if="item[`lesson${keyword}Type`].match(/^C/)" class="detail">
                                        횟수 별 금액 -
                                        <span v-for="(data, idx) in item[`lesson${keyword}Ranges`]" :key="idx">
                                            {{ data.rangeCount }}회
                                            {{ idx !== item[`lesson${keyword}Ranges`].length - 1 ? '이하' : '초과' }}
                                            {{ data.rangeValue | numberFormatFilter }}
                                            {{ getDimension(item[`lesson${keyword}Type`]) }}
                                            <span v-show="idx !== item[`lesson${keyword}Ranges`].length - 1">/</span>
                                        </span>
                                    </span>
                                    <span v-else-if="item[`lesson${keyword}Type`] === 'MT'" class="detail">
                                        인원 별 금액 -
                                        <span v-for="(data, idx) in item[`lesson${keyword}Ranges`]" :key="idx">
                                            {{ data.rangeCount }}명
                                            {{ idx !== item[`lesson${keyword}Ranges`].length - 1 ? '이하' : '초과' }}
                                            {{ data.rangeValue | numberFormatFilter }}
                                            {{ getDimension(item[`lesson${keyword}Type`]) }}
                                            <span v-show="idx !== item[`lesson${keyword}Ranges`].length - 1">/</span>
                                        </span>
                                    </span>
                                    <span class="txt red">
                                        {{
                                            getAtndString(
                                                item[`lesson${keyword}AtndType`],
                                                item[`lesson${keyword}AtndTypeValue`]
                                            )
                                        }}
                                    </span>
                                </div>
                                <button v-if="index === 0" class="com-btn red" @click="removeSalarySetting">
                                    삭제
                                </button>
                            </li>
                        </ul>
                        <b-pagination
                            v-model="pagingInfo.page"
                            :per-page="pagingInfo.limit"
                            :total-rows="pagingInfo.totalItems"
                            align="center"
                            aria-controls="my-table"
                            first-class="first"
                            last-class="last"
                            next-class="next"
                            prev-class="prev"
                            @change="handlerPagenation($event)"
                        ></b-pagination>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import { Utils as utils } from '../../../assets/js/utils';
import moment from 'moment';
import LoadingSpinner from '../../../components/LoadingSpinner';
import BtnLoadingSpinner from '../../../components/BtnLoadingSpinner';
import SalaryType from './EmployeeSalaryType';
import SalaryVat from './EmployeeSalaryVat';
import { pagingInfo } from '@/assets/js/common';
import SalaryTax from './EmployeeSalaryTax';

export default {
    name: 'SettingEmployeeSalary',
    components: {
        LoadingSpinner,
        BtnLoadingSpinner,
        SalaryType,
        SalaryVat,
        SalaryTax,
    },

    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    data() {
        return {
            loginCenterId: '',
            isLoading: false,
            isSaving: false,
            isHistoryLoading: false,
            centerStaffId: this.$route.params.centerStaffId,
            data: {
                incentiveYn: false,
                incentiveVatYn: false,
                taxWithholdingAppliedYn: false,
                applyEndDate: '',
                applyStartDate: '',
                countSetting: ['N', 'N', 'N', 'N'],
                lessonDuetAtndType: 'CME',
                lessonDuetAtndTypeValue: 0,
                lessonDuetAtndTypeValuePrice: 0,
                lessonDuetAtndTypeValuePercent: 0,
                lessonDuetPrice: '0',
                lessonDuetType: 'FA',
                lessonDuetVatYn: false,
                lessonDuetRanges: [],
                lessonGroupAtndType: 'CME',
                lessonGroupAtndTypeValue: 0,
                lessonGroupAtndTypeValuePrice: 0,
                lessonGroupAtndTypeValuePercent: 0,
                lessonGroupPrice: '0',
                lessonGroupType: 'TM',
                lessonGroupVatYn: false,
                lessonGroupRanges: [],
                lessonOtAtndType: 'CME',
                lessonOtAtndTypeValue: 0,
                lessonOtAtndTypeValuePrice: 0,
                lessonOtAtndTypeValuePercent: 0,
                lessonOtPrice: '0',
                lessonOtType: 'FA',
                lessonOtVatYn: false,
                lessonOtRanges: [],
                lessonPersonAtndType: 'CME',
                lessonPersonAtndTypeValue: 0,
                lessonPersonAtndTypeValuePrice: 0,
                lessonPersonAtndTypeValuePercent: 0,
                lessonPersonPrice: '0',
                lessonPersonType: 'FA',
                lessonPersonVatYn: false,
                lessonPersonRanges: [],
            },
            history: [], // 급여변동 내역
            historyPop: false, // 급여변동 내역보기 팝업
            defaultSettingPop: false, // 기본설정 팝업
            ticketSettingPop: false, // 이용권별 팝업
            codes: {},
            fields: {
                less_p_type_cd: 'lessonPersonType',
                less_p_atnd_type_cd: 'lessonPersonAtndType',
                less_o_type_cd: 'lessonGroupType',
                less_o_atnd_type_cd: 'lessonGroupAtndType',
                less_g_type_cd: 'lessonOtType',
                less_g_atnd_type_cd: 'lessonOtAtndType',
                less_d_type_cd: 'lessonDuetType',
                less_d_atnd_type_c: 'lessonDuetAtndType',
                less_type_cd: 'countSetting',
            },
            incentiveKind: 'no',
            selectedLessonTypes: [],
            isBlock: false,
            orgLessonDuetType: '',
            orgLessonGroupType: '',
            pagingInfo: { ...pagingInfo },
        };
    },
    watch: {
        incentiveNewSaleYn(v) {
            this.data.incentiveYn = true;
        },
        // data: {
        //     deep: true,
        //     handler(v) {
        //         ['Person', 'Duet', 'Ot', 'Group'].forEach((o, index) => {
        //             if (parseInt(this.data[`lesson${o}AtndTypeValuePrice`], 10) < 0) {
        //                 this.data[`lesson${o}AtndTypeValuePrice`] = '0';
        //             }

        //             if (parseInt(this.data[`lesson${o}AtndTypeValuePercent`], 10) < 0) {
        //                 this.data[`lesson${o}AtndTypeValuePercent`] = '0';
        //             } else if (parseInt(this.data[`lesson${o}AtndTypeValuePercent`], 10) >= 100) {
        //                 this.data[`lesson${o}AtndTypeValuePercent`] = '100';
        //             }

        //             if ((this.data[`lesson${o}AtndType`] || '').search(/F$/) >= 0) {
        //                 this.data[`lesson${o}AtndTypeValue`] = this.data[`lesson${o}AtndTypeValuePrice`];
        //             } else if ((this.data[`lesson${o}AtndType`] || '').search(/P$/) >= 0) {
        //                 this.data[`lesson${o}AtndTypeValue`] = this.data[`lesson${o}AtndTypeValuePercent`];
        //             }

        //             if (this.data[`lesson${o}Type`] === 'CP' || this.data[`lesson${o}Type`] === 'CA') {
        //                 this.data['countSetting'][index] = 'Y';
        //             } else {
        //                 this.data['countSetting'][index] = 'N';
        //             }
        //         });
        //         this.$forceUpdate();
        //     },
        // },

        'data.incentiveNewSale': function (v) {
            if (parseInt(v) < 1) {
                alert('1% 이상 입력 가능합니다');
                this.data.incentiveNewSale = '';
            }
        },
        'data.incentiveRenewSale': function (v) {
            if (parseInt(v) < 1) {
                alert('1% 이상 입력 가능합니다');
                this.data.incentiveRenewSale = '';
            }
        },
        'data.incentiveTotalSale': function (v) {
            if (parseInt(v) < 1) {
                alert('1% 이상 입력 가능합니다');
                this.data.incentiveTotalSale = '';
            }
        },
        'data.applyEndDate': function (v) {
            this.data.applyStartDate = this.$moment(v).add(1, 'month').format('YYYY-MM');
            // this.$withoutWatchers(() => {
            //     this.data.applyEndDate = this.$moment(v).format('YYYY-MM');
            // });
        },
        incentiveKind(kind) {
            if (kind === 'no') {
                this.data.incentiveNewSale = '';
                this.data.incentiveRenewSale = '';
                this.data.incentiveTotalSale = '';
                this.data.incentiveYn = false;
            }

            this.data.incentiveYn = true;

            if (kind === 'new') {
                this.data.incentiveRenewSale = '';
                this.data.incentiveTotalSale = '';
            } else if (kind === 'renew') {
                this.data.incentiveNewSale = '';
                this.data.incentiveTotalSale = '';
            } else if (kind === 'total') {
                this.data.incentiveNewSale = '';
                this.data.incentiveRenewSale = '';
            }
        },
    },
    async mounted() {
        await this.init();
    },
    methods: {
        async init() {
            this.loginCenterId = parseInt(this.cId);
            // this.pagingInfo.limit = 10;

            const codes = {};
            (
                await this.$getSystemCode({
                    center_staff_pay_setting: [
                        'less_p_type_cd',
                        'less_p_atnd_type_cd',
                        'less_o_type_cd',
                        'less_o_atnd_type_cd',
                        'less_g_type_cd',
                        'less_g_atnd_type_cd',
                        'less_d_type_cd',
                        'less_d_atnd_type_cd',
                    ],
                    center_staff_pay_setting_range: ['less_type_cd'],
                })
            ).forEach((o) => {
                codes[o[0].columnName] = o.map((e) => ({
                    text: e.codeDesc,
                    value: e.codeName,
                }));
            });
            codes.less_type_cd.sort((o1, o2) => ('PDOG'.indexOf(o1.value) < 'PDOG'.indexOf(o2.value) ? -1 : 1));
            this.$set(this, 'codes', codes);

            await this.loadDetailInfo();
        },
        getBaseParams() {
            let {
                basePay,
                incentiveYn,
                incentiveNewSale,
                incentiveRenewSale,
                incentiveTotalSale,
                incentiveVatYn,
                applyStartDate,
                applyEndDate,
                taxWithholdingAppliedYn,
            } = this.data;
            if (basePay == null) basePay = 0;
            const totalDay = moment(applyEndDate).daysInMonth();
            console.log(totalDay);
            applyStartDate += '-01';
            try {
                applyEndDate = applyEndDate.format('YYYY-MM');
            } catch (e) {}

            applyEndDate += `-${totalDay}`;
            const data = {
                basePay,
                incentiveYn,
                incentiveVatYn,
                applyStartDate,
                applyEndDate,
                taxWithholdingAppliedYn,
            };

            if (this.incentiveKind === 'new') {
                data.incentiveNewSale = incentiveNewSale;
            } else if (this.incentiveKind === 'renew') {
                data.incentiveRenewSale = incentiveRenewSale;
            } else if (this.incentiveKind === 'total') {
                data.incentiveTotalSale = incentiveTotalSale;
            }

            return data;

            /*
api.put(`/admin/api/center/${this.loginCenterId}/staff/${this.centerStaffId}/pay/setting/update/base`, data)
.then(res => {
  this.isSaving = false;
  this.defaultSettingPop = false;
})
.catch(res => {
  this.isSaving = false;
  if (res.status != 404) alert(`오류가 발생했습니다.\n${res}`);
  console.error(res);
});
*/
        },
        getTicketParams() {
            // const data = eval('(' + JSON.stringify(this.data) + ')');
            const {
                // 듀엣 설정
                lessonDuetAtndType,
                lessonDuetPriceVatYn,
                lessonDuetType,
                lessonDuetRanges,
                // 그룹/쿠폰 설정
                lessonGroupAtndType,
                lessonGroupPriceVatYn,
                lessonGroupType,
                lessonGroupRanges,
                // OT 설정
                lessonOtAtndType,
                lessonOtPriceVatYn,
                lessonOtType,
                lessonOtRanges,
                // 개인 설정
                lessonPersonAtndType,
                lessonPersonPriceVatYn,
                lessonPersonType,
                lessonPersonRanges,
            } = this.data;
            console.log('data', this.data);
            console.log('0', this.data.countSetting);
            const countSetting = this.data.countSetting.join('');
            console.log('1', countSetting);
            const data = {
                countSetting,
                lessonDuetAtndType,
                lessonDuetPriceVatYn,
                lessonDuetType,
                lessonDuetRanges,
                lessonGroupAtndType,
                lessonGroupPriceVatYn,
                lessonGroupType,
                lessonGroupRanges,
                lessonOtAtndType,
                lessonOtPriceVatYn,
                lessonOtType,
                lessonOtRanges,
                lessonPersonAtndType,
                lessonPersonPriceVatYn,
                lessonPersonType,
                lessonPersonRanges,
            };

            ['Person', 'Duet', 'Ot', 'Group'].forEach((keyword) => {
                if (data[`lesson${keyword}AtndType`] === 'CMF' || data[`lesson${keyword}AtndType`] === 'CMP') {
                    if (utils.isEmpty(this.data[`lesson${keyword}AtndTypeValue`])) {
                        data[`lesson${keyword}AtndTypeValue`] = 0;
                    } else {
                        data[`lesson${keyword}AtndTypeValue`] = this.data[`lesson${keyword}AtndTypeValue`];
                    }
                }

                if (data[`lesson${keyword}Type`] === 'CP' || data[`lesson${keyword}Type`] === 'CA') {
                    if (utils.isEmpty(this.data[`lesson${keyword}Ranges`])) {
                        data[`lesson${keyword}Ranges`] = [];
                    } else {
                        data[`lesson${keyword}Ranges`] = this.data[`lesson${keyword}Ranges`];
                    }
                } else if (utils.isEmpty(this.data[`lesson${keyword}Price`])) {
                    data[`lesson${keyword}Price`] = 0;
                } else {
                    data[`lesson${keyword}Price`] = this.data[`lesson${keyword}Price`];
                }
            });

            return data;
        },
        async loadDetailInfo() {
            try {
                // 스웨거 검색: 센터직원 급여 세팅정보 상세조회
                const { data } = await api.get(
                    `/admin/api/center/${this.loginCenterId}/staff/${this.centerStaffId}/pay/setting/detail`,
                    {
                        applyDate: moment().format('YYYY-MM-DD'),
                    }
                );
                console.log('직원급여설정', data);

                // this.data = data;
                // console.log(data.lessonDuetType);
                this.orgLessonDuetType = data.lessonDuetType;
                this.orgLessonGroupType = data.lessonGroupType;
                this.data = this.adjustData(data);
                this.data.countSetting = data.countSetting.split('');
                this.selectedLessonTypes = [];
                ['Person', 'Duet', 'Ot', 'Group'].forEach((keyword) => {
                    this.selectedLessonTypes.push(this.data[`lesson${keyword}Type`]);
                });

                if (data.incentiveYn) {
                    if (data.incentiveNewSale > 0 || !utils.isEmpty(data.incentiveNewSale)) {
                        this.incentiveKind = 'new';
                    } else if (data.incentiveRenewSale > 0 || !utils.isEmpty(data.incentiveRenewSale)) {
                        this.incentiveKind = 'renew';
                    } else if (data.incentiveTotalSale > 0 || !utils.isEmpty(data.incentiveTotalSale)) {
                        this.incentiveKind = 'total';
                    }
                } else {
                    this.incentiveKind = 'no';
                }

                this.data.applyEndDate = moment().subtract(1, 'month').format('YYYY-MM');
                this.data.applyStartDate = moment().format('YYYY-MM');
            } catch (err) {
                console.error(err);
                this.loading = false;
                // for (const key in err) {
                //     console.log(key, err[key]);
                // }
            }
        },
        async loadHistory() {
            this.isHistoryLoading = true;
            try {
                // 스웨거 검색: 센터직원 급여세팅정보 페이징 이력 목록 조회
                const { data } = await api.get(
                    `/admin/api/center/${this.loginCenterId}/staff/${this.centerStaffId}/pay/setting/history`,
                    { params: this.pagingInfo }
                );
                this.isHistoryLoading = false;
                this.history = data.items;

                let prevEnd = null;
                this.history.forEach((o, i) => {
                    if (prevEnd && o.length > 3) {
                        o.applyStartDate = prevEnd;
                    }
                    if (this.pagingInfo.page == 1 && i == 0) {
                        // 제일 최근, End 가 현재
                        // o.applyEndDate = '현재';
                    } else {
                        prevEnd = o.applyEndDate;
                    }
                });
            } catch (err) {
                console.error(err);
            }
        },
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        // 페이지 변경 Handler
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.loadHistory();
        },
        openHistoryPop() {
            this.pagingInfo.page = 1;
            this.loadHistory();
            this.historyPop = true;
        },
        adjustData(data) {
            ['Person', 'Duet', 'Ot', 'Group'].forEach((keyword) => {
                if (data[`lesson${keyword}AtndType`] === 'CMF') {
                    data[`lesson${keyword}AtndTypeValuePrice`] = data[`lesson${keyword}AtndTypeValue`];
                } else if (data[`lesson${keyword}AtndType`] === 'CMP') {
                    data[`lesson${keyword}AtndTypeValuePercent`] = data[`lesson${keyword}AtndTypeValue`];
                }
            });
            console.log('incentiveVatYn', data.incentiveVatYn);
            data.applyEndDate = utils.isEmpty(data.applyEndDate) ? moment().format('YYYY-MM') : data.applyEndDate;
            data.applyStartDate = utils.isEmpty(data.applyStartDate)
                ? moment().add(1, 'month').format('YYYY-MM')
                : data.applyStartDate;
            data.incentiveVatYn = utils.isEmpty(data.incentiveVatYn) ? true : data.incentiveVatYn;
            data.lessonPersonPriceVatYn = utils.isEmpty(data.lessonPersonPriceVatYn)
                ? true
                : data.lessonPersonPriceVatYn;
            data.lessonDuetPriceVatYn = utils.isEmpty(data.lessonDuetPriceVatYn) ? true : data.lessonDuetPriceVatYn;
            data.lessonOtPriceVatYn = utils.isEmpty(data.lessonOtPriceVatYn) ? true : data.lessonOtPriceVatYn;
            data.lessonGroupPriceVatYn = utils.isEmpty(data.lessonGroupPriceVatYn) ? true : data.lessonGroupPriceVatYn;
            data.taxWithholdingAppliedYn = utils.isEmpty(data.taxWithholdingAppliedYn)
                ? false
                : data.taxWithholdingAppliedYn;

            return data;
        },
        changeData(data) {
            this.data = data;
        },
        isDisabled(index) {
            const keywords = ['Person', 'Duet', 'Ot', 'Group'];
            const keyword = keywords[index];

            if (this.data[`lesson${keyword}Type`] === 'CP' || this.data[`lesson${keyword}Type`] === 'CA') {
                this.data.countSetting[index] = 'Y';
                return true;
            }

            // this.data.countSetting[index] = 'N';
            return false;
        },
        async save() {
            const validate = this.validate();
            if (!validate) {
                alert('매출 인센티브는 오직 정수만 입력해야 합니다.');
                return;
            }
            this.ticketSettingPop = false;
            const baseParams = this.getBaseParams();
            const ticketParams = this.getTicketParams();
            this.isSaving = true;
            try {
                await api.post(`/admin/api/center/${this.loginCenterId}/staff/${this.centerStaffId}/pay/setting/save`, {
                    ...baseParams,
                    ...ticketParams,
                });
                this.isSaving = false;
                await this.loadDetailInfo();
                alert('급여설정이 수정되었습니다.');
                this.$router.go(-1);
            } catch (error) {
                this.isSaving = false;
                console.error(error);
            }
            /*
api.put(`/admin/api/center/${this.loginCenterId}/staff/${this.centerStaffId}/pay/setting/update/base`, baseParams)
.then(() => {
  this.isSaving = true;
  return api.put(`/admin/api/center/${this.loginCenterId}/staff/${this.centerStaffId}/pay/setting/update/ticket`, ticketParams);
})
.then(() => {
  this.isSaving = false;
  alert('저장했습니다.');
})
.catch(res => {
  this.isSaving = false;


  if (res.status != 404) alert(`오류가 발생했습니다.\n${res.response.data.message}`);
  console.error(res);
});
*/
        },
        getLessonTypeString(lessonType) {
            if (lessonType === 'FA') return '고정금액';
            else if (lessonType === 'FP') return '고정퍼센트';
            else if (lessonType === 'CA') return '횟수 별 금액';
            else if (lessonType === 'CP') return '횟수 별 퍼센트';
            else if (lessonType === 'TM') return '타임별';
            else if (lessonType === 'MO') return '인당';
            else if (lessonType === 'MT') return '인원별';
        },
        getDimension(lessonType) {
            if (lessonType.match(/FP|CP/)) return '%';
            return '원';
        },
        getTicketTitle(keyword) {
            if (keyword === 'Person') return '개인';
            else if (keyword === 'Duet') return '듀엣';
            else if (keyword === 'Ot') return 'OT';
            else if (keyword === 'Group') return '그룹';
        },
        // 급여 변동 내역을 삭제하는 함수
        async removeSalarySetting() {
            this.isLoading = true;
            try {
                // 스웨거 검색: 직원관리 > 급여설정 삭제
                await api.delete(
                    `/admin/api/center/${this.loginCenterId}/staff/${this.centerStaffId}/pay/setting/delete`
                );
                await this.loadDetailInfo();
                this.historyPop = false;
                this.isLoading = false;
                alert('삭제하였습니다.');
            } catch (error) {
                await this.loadDetailInfo();
                alert('오류가 발생했습니다.');
                console.error(error);
                this.historyPop = false;
                this.isLoading = false;
            }
        },
        validate() {
            if (this.data.incentiveNewSale) {
                return Number.isInteger(Number(this.data.incentiveNewSale));
            }

            if (this.data.incentiveRenewSale) {
                return Number.isInteger(Number(this.data.incentiveRenewSale));
            }

            if (this.data.incentiveTotalSale) {
                return Number.isInteger(Number(this.data.incentiveTotalSale));
            }
            if (this.data.lessonGroupRanges) {
                if (this.data.lessonGroupRanges.length > 1) {
                    try {
                        for (const i of this.data.lessonGroupRanges) {
                            if (!(i.rangeCount && i.rangeValue)) {
                                throw new Error();
                                break;
                            } else {
                                i.rangeCount = i.rangeCount.toString().replaceAll(/[^0-9]/g, '');
                                i.rangeValue = i.rangeValue.toString().replaceAll(/[^0-9]/g, '');
                                if (i.rangeCount === '' || i.rangeValue === '') {
                                    throw new Error();
                                    break;
                                }
                            }
                        }
                    } catch (e) {
                        alert('인원별 급여 설정 값을 확인 해주세요');
                        console.log(e);
                        throw new Error();
                    }
                } else {
                    alert('인원별 급여 설정 값을 확인 해주세요');
                    throw new Error();
                }
            }
            return true;
        },
        changeValue(index) {
            const value = this.data.countSetting[index];
            this.data.countSetting[index] = value === 'Y' ? 'N' : 'Y';
            console.log(this.data.countSetting);
        },
        getAtndString(lessonAtndType, lessonAtndTypeValue) {
            if (lessonAtndType === 'CME') {
                return '(결석 - 동일금액)';
            } else if (lessonAtndType === 'CMF') {
                return `(결석 - ${utils.getNumberFormat(lessonAtndTypeValue)}원 정산)`;
            } else if (lessonAtndType === 'CMP') {
                return `(결석 - 기존금액의 ${lessonAtndTypeValue}%)`;
            } else if (lessonAtndType === 'CXX') {
                return '(결석 - 0원 정산)';
            }
        },
        next() {
            this.defaultSettingPop = false;
            this.ticketSettingPop = true;
        },
        paySettingModify() {
            if (
                this.orgLessonDuetType !== this.data.lessonDuetType ||
                this.orgLessonGroupType !== this.data.lessonGroupType
            ) {
                this.defaultSettingPop = true;
            } else {
                this.ticketSettingPop = true;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.bottom-btn {
    .spinner-container {
        margin: auto;
    }
}

.com-card-input .input-cnt.box-type .btn-cnt {
    position: absolute;
    left: 410px;
    bottom: 32px;
}
</style>
